// Function to navigate to a specific image in the swiper
function swipeToImageId(id) {
  id = id.toString();
  var swiper = document.querySelector("#productSwiper")
    ? document.querySelector("#productSwiper").swiper
    : undefined;
  for (var i = 0; i < swiper.slides.length; i++) {
    var slide = swiper.slides[i];
    var slideId = slide.getAttribute("data-image-id");
    if (slideId === id) {
      swiper.slideTo(i);
      break;
    }
  }
}

// Initialize swiper for product buttons
var swiperButtons = new Swiper("#productButtonsSwiper", {
  loop: false,
  spaceBetween: 20,
  slidesPerView: 4,
  freeMode: false,
  slideToClickedSlide: true,
  allowTouchMove: true,
  centeredSlides: false,
  watchOverflow: true,
  watchSlidesVisibility: true,
    watchSlidesProgress: true,
  lazy: true,
  keyboard: {
    enabled: true,
  },
  breakpoints: {
    480: {
      slidesPerView: 3,
    },
    767: {
      slidesPerView: 4,
    },
  },
});

// Initialize main product swiper
var productSwiper = new Swiper("#productSwiper", {
  spaceBetween: 16,
  slidesPerView: 1,
  loop: false,
  // mousewheel: true,
  // Navigation options
  navigation: {
    nextEl: "#productArrowNext",
    prevEl: "#productArrowPrev",
  },
  // Pagination options
  // pagination: {
  //   el: "#productPagination",
  //   type: "bullets",
  //   clickable: true,
  // },
  // Thumbs navigation
  thumbs: {
    swiper: swiperButtons,
  },
});

productSwiper.on('slideChangeTransitionStart', function() {
    swiperButtons.slideTo(productSwiper.activeIndex);
});

swiperButtons.on('transitionStart', function(){
    productSwiper.slideTo(swiperButtons.activeIndex);
});



// Function to handle body scroll when mobile menu is open
let menu = document.querySelector(".menu-button-wrapper");
let tempMenuElem = menu ? menu.innerHTML : '';

var body = document.body;
function letBodyScroll(bool) {
  var phoneNr = document.querySelector("#nav-phone-nr");

  if (bool) {
    //body.style.overflow = "hidden";
    if (phoneNr) phoneNr.style.opacity = "0";
    if (menu) {
      const newLineDiv1 = document.createElement("div");
      const newLineDiv2 = document.createElement("div");
      newLineDiv1.classList.add('menu-button-icon-top', 'close');
      newLineDiv2.classList.add('menu-button-icon-bottom', 'close');
      menu.innerHTML = "";
      menu.appendChild(newLineDiv1);
      menu.appendChild(newLineDiv2);
    }
  } else {
    //body.style.overflow = "auto";
    // restore the logo FIRST so it can never be skipped
    if (phoneNr) phoneNr.style.opacity = "1";
    if (menu) menu.innerHTML = tempMenuElem;
  }
}

// Observe changes in the mobile menu and adjust body scroll
var targetNode = document.querySelector(".w-nav-button");
var config = { attributes: true, childList: false, subtree: false };
var callback = function (mutationsList, observer) {
  for (var i = 0; i < mutationsList.length; i++) {
    if (mutationsList[i].type === "attributes") {
      var menuIsOpen = mutationsList[i].target.classList.contains("w--open");
      letBodyScroll(menuIsOpen);
    }
  }
};
var observer = new MutationObserver(callback);
if (targetNode) observer.observe(targetNode, config);

// Function to fetch and render cart count
function renderCartCount() {
  fetch("/cart.json")
    .then(function (r) {
      return r.json();
    })
    .then(function (json) {
      document.querySelectorAll(".cart-count").forEach(function (e) {
        e.textContent = json.item_count;
      });
    });
}

// Initial rendering of cart count
renderCartCount();

function setupVideoPlayer() {
  // Check if the video element exists
  var video = document.querySelector(".jewelry-video > video");
  if (!video) {
    // No video section on this page — nothing to set up.
    return;
  }

  var playButton = document.querySelector(".video-play-button");
  if (!playButton) return;

  playButton.addEventListener("click", function () {
    if (video.paused) {
      video.play();
      playButton.classList.add("playing");
    } else {
      video.pause();
      playButton.classList.remove("playing");
    }
  });

  // Check if the video is playing with native controls
  video.addEventListener("playing", function () {
    playButton.classList.add("playing");
  });

  video.addEventListener("pause", function () {
    playButton.classList.remove("playing");
  });

  // Pause the video when clicking outside the video area
  document.body.addEventListener("click", function (event) {
    if (!event.target.closest(".jewelry-video")) {
      video.pause();
      playButton.classList.remove("playing");
    }
  });

  // Add a class to the video when it enters fullscreen
  document.addEventListener("fullscreenchange", function () {
    if (isVideoInFullscreen()) {
      video.classList.add("fullscreen");
    } else {
      video.classList.remove("fullscreen");
    }
  });

  // Check if the video element is in fullscreen
  function isVideoInFullscreen() {
    return document.fullscreenElement === video;
  }
}

setupVideoPlayer();

// Product page dropdown accordion
jQuery(document).ready(function($) {
 $('.dropdown-title').on('click', function() {
    $(this).next().slideToggle();
 });
});



$(document).ready(function() {
    // Initially hide all sub-menus
    $("#top-menu li ul.sub-menu").hide();

    // Add toggle functionality for list items with the 'has-child' class
    $("#top-menu li.has-child").click(function(e) {
        e.stopPropagation(); // Prevent event bubbling
        e.preventDefault();
        $(this).children("ul.sub-menu").slideToggle();
        $(this).toggleClass("sub-menu-open");
    });
    // Allow clicking inside sub-menu items without toggling
    $("#top-menu li ul.sub-menu li a").click(function(e) {
        e.stopPropagation(); // Prevent the toggle from closing
        // Let the default action (navigation) happen
    });
});

// Image grid gallery section
if ($(".cl01").length) {
    $(".cl01-apix").click(function() {
        var box_id = $(this).parents(".cl01").attr("id");
        from_img = $(this).children("img");
        from_src = from_img.attr("src");
        to_img = $("#" + box_id).find(".cl01-bigpix");
        to_src = to_img.attr("src");
        to_img.fadeOut("fast");
        from_img.fadeOut("fast", function() {
            from_img.attr("src", to_src).fadeIn("fast");
            to_img.attr("src", from_src).fadeIn("fast")
        });
        return false
    })
}

// add dynamic padding for transparent nav
document.addEventListener("DOMContentLoaded", function () {
    const navPadding = document.querySelector("#nav-padding");
    const bannerBg = document.querySelector(".banner-bg");

    if (navPadding && bannerBg && navPadding.getAttribute("data-header") === "fixed") {
        const navHeight = navPadding.offsetHeight;
        bannerBg.style.paddingTop = `${navHeight}px`;
    }
});
